<template>
    <div class="header__tour">
        <div class="container">
            <v-tour
                ref="vtour"
                name="myTour"
                :steps="steps"
                :options="{
                    highlight: true
                }"
                :callbacks="myCallbacks"
            >
            </v-tour>
        </div>
    </div>
</template>

<script>
import { User } from '@/User'
import { Storage } from '@/Storage'

export default {
  name: 'header-tour',
  data () {
    return {
      user: new User(),
      myCallbacks: {
        onPreviousStep: this.handlePreviousStepCallback,
        onNextStep: this.handleNextStepCallback,
        onStop: this.handleStopCallback,
        onSkip: this.handleSkipCallback,
        onFinish: this.handleFinishCallback
      }
    }
  },
  computed: {
    steps () {
      const loggedInUserId = this.$store.getters.getAuthUserSecondStageTokenDataUserId
      const userTourStorage = Storage.getLocal('userTourStorage') ? JSON.parse(Storage.getLocal('userTourStorage')) : null
      const userLastTourFinishedDate = userTourStorage && userTourStorage.date ? new Date(userTourStorage.date) : null
      const userLastTourFinishedId = userTourStorage && userTourStorage.userId ? userTourStorage.userId : null
      const userAccountCreateDate = this.user.createdAt ? new Date(this.user.createdAt) : null
      const tourReleaseDates = [
        {
          name: 4,
          date: '2022-01-12'
        }
      ]
      let stepsArr = [
        {
          extra: {
            tourName: 4,
            requiresNewLMS: true
          },
          target: '[data-v-step="3"]',
          header: {
            title: 'What’s new in Form LMS'
          },
          content: `See the highlights from the latest release.`
        }
      ]

      let stepsArrFiltered = []

      for (let step of stepsArr) {
        const stepReleaseDate = new Date(tourReleaseDates.find(obj => obj.name === step.extra.tourName).date)
        const isSecondStageTokenFromOldLMS = this.user.isTokenFromOldLms()
        const requiresNewLMS = step.extra.requiresNewLMS
        const requiresAnyCustomerService = step.extra.requiresAnyCustomerService
        const requiresAnyCustomerRole = step.extra.requiresAnyCustomerRole
        const requiresAnyPermission = step.extra.requiresAnyPermission
        const requiresAnyRole = step.extra.requiresAnyRole
        const requiresRoleOrPermissions = step.extra.requiresRoleOrPermissions
        const requiresRoleOrService = step.extra.requiresRoleOrService

        const checkHasAnyRole = requiresAnyRole ? this.user.hasAnyRole(requiresAnyRole) : false
        const checkHasAnyCustomerRole = requiresAnyCustomerRole ? this.user.hasAnyCustomerRole(requiresAnyCustomerRole) : false
        const checkHasAnyPermission = requiresAnyPermission ? this.user.hasAnyPermission(requiresAnyPermission) : false
        const checkHasAnyCustomerService = requiresAnyCustomerService ? this.user.hasAnyCustomerService(requiresAnyCustomerService) : false

        if (requiresNewLMS && !this.user.isTokenFromNewLms()) {
          continue
        }

        if (userLastTourFinishedId && userLastTourFinishedId === loggedInUserId) {
          if (userLastTourFinishedDate && stepReleaseDate < userLastTourFinishedDate) {
            continue
          }
          if (userAccountCreateDate && stepReleaseDate < userAccountCreateDate) {
            continue
          }
        }

        if (requiresRoleOrPermissions) {
          if ((requiresAnyRole || requiresAnyCustomerRole) && requiresAnyPermission) {
            if ((!checkHasAnyRole && !checkHasAnyCustomerRole) && !checkHasAnyPermission) {
              continue
            }
          }
        } else {
          if ((requiresAnyRole || requiresAnyCustomerRole)) {
            if ((!checkHasAnyRole && !checkHasAnyCustomerRole)) {
              continue
            }
          }
          if (requiresAnyPermission) {
            if (!checkHasAnyPermission) {
              continue
            }
          }
        }
        if (requiresRoleOrService && !isSecondStageTokenFromOldLMS) {
          if ((requiresAnyRole || requiresAnyCustomerRole) && requiresAnyCustomerService) {
            if ((!checkHasAnyRole && !checkHasAnyCustomerRole) && !checkHasAnyCustomerService) {
              continue
            }
          }
        } else {
          if (requiresAnyCustomerService) {
            if (!checkHasAnyCustomerService && !isSecondStageTokenFromOldLMS) {
              continue
            }
          }
        }

        stepsArrFiltered.push(step)
      }

      return stepsArrFiltered
    }
  },
  methods: {
    startTour () {
      this.$tours['myTour'].start()
      this.handleRegenerateButtonsClasses()
    },
    handlePreviousStepCallback () {
      this.handleRegenerateButtonsClasses()
    },
    handleNextStepCallback () {
      this.handleRegenerateButtonsClasses()
    },
    handleStopCallback () {
      this.setLastTourFinished()
    },
    handleSkipCallback () {
      this.setLastTourFinished()
    },
    handleFinishCallback () {
      this.setLastTourFinished()
    },
    setLastTourFinished () {
      Storage.setLocal('userTourStorage', JSON.stringify({
        date: new Date(),
        userId: this.user.data.userId
      }))
    },
    handleRegenerateButtonsClasses () {
      const tourEl = this.$tours['myTour'].$el
      let buttons = tourEl ? tourEl.getElementsByClassName('v-step__button') : ''
      let regenerateInterval

      regenerateInterval = setInterval(() => {
        for (let i in buttons) {
          let button = buttons[i]

          if (button.constructor !== HTMLButtonElement) continue

          if (!button.classList.contains('btn')) {
            button.classList.add('btn')
            button.innerHTML = '<span>' + button.innerHTML + '</span>'
          }
          if (button.classList.contains('v-step__button-next') || button.classList.contains('v-step__button-stop')) {
            button.classList.add('btn--primary')
          } else {
            button.classList.add('btn--default')
          }

          if (Number(i) === Number(buttons.length - 1)) {
            clearInterval(regenerateInterval)
          }
        }
      }, 100)
    }
  },
  mounted () {
    this.$eventBus.$on('workspace-access', () => {
      this.user = new User()
      this.$forceUpdate()
      setTimeout(this.startTour, 1000)
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('workspace-access')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/headertour";
</style>
